import styled from 'styled-components';

// ############################ Imported from Old UI ###########################

export default styled.a(({ theme }) => ({
  cursor: 'pointer',
  fontWeight: 'bold',
  color: theme.colors.primaryBright,
  textDecoration: 'none',
  '&.disabled': {
    pointerEvents: 'none',
    color: theme.colors.mediumGray,
  },
}));
